
const watermarkHelper = require("./formConfig/watermarkHelper");

module.exports = function () {
    var _this = this;

    this.getParentSimpleList = function (element, container = this._currentContainer) {
        return container.pages.reduce(function (obj, page) {
            let x = page.fields.reduce(function (obj1, field) {
                if (field.type == "simplelist") {
                    if (field.nodes.includes(element) || (field.nodes.findIndex(el => el.type == "group" && el.nodes.includes(element)) >= 0))
                        return field.id
                }
                if (field.type == "group") {
                    let idx = field.nodes.findIndex(el => el.type == "simplelist" && el.nodes.includes(element));
                    if (idx >= 0)
                        return field.nodes[idx].id
                }
                return obj1;
            }, undefined);
            if (x)
                return x;
            else
                return obj;
        }, undefined);
    }

    this.getReportConfigInit = () => {
        return {
            includeFormTitle: true,
            includeFormDesc: true,
            includeDate: true,
            includeMemberName: true,
            boldTitles: true,
            showGeoMap: true,
            useSatMap: false,
            rowsToColumns: false,
            logo: false,
            validate: true,
            validate_title: true,
            validate_state: true,
            validate_fields: true,
            photosPerRow: 3,
            reportSchema : "custom", 
            gridOf :"grid-of-1",
            interline : "interline1px",
            maxHeightPhotoInForm : "5",
            customFooter :" ",
            customHeader : " ", 
            pageOrientation : "portrait",
            pageSize : "A4",
            watermark: watermarkHelper.getDefaults()
        }
    }

    this.getListOfElements = (fields, evalTypes, evalAction="exclude") => {
        return fields.reduce((lst, field) => {
            if ((evalAction == "exclude" && evalTypes?.includes(field.type) )|| (evalAction == "include" && !evalTypes?.includes(field.type) ))
                return lst;
            switch (field.type) {
                case "group":
                    lst = lst.concat(_this.getListOfElements(field.nodes));
                    break;
                default:
                    lst.push(field);
            }
            return lst;
        }, []);
    }

    this.getElements = function (type, element, checkOptions = false, container = this._currentContainer, includeNodesSimpleList = false) {
        let nodesFields = container.pages
        if (type != 'simplelist' && element.templateData && element.templateData.fxScope && element.templateData.fxScope != "") {
            //Find Simple List field to get list of nodes
            nodesFields = container.pages.reduce(function (objScope, page) {
                //let obj=page.fields.find(function(el){if(el.id==element.templateData.fxScope) return true});
                let obj = page.fields.reduce(function (res, el) {
                    if (res) return res;
                    if (el.id == element.templateData.fxScope) return el;
                    if (el.nodes) {
                        return el.nodes.reduce(function (res2, el2) {
                            if (res2) return res2
                            if (el2.id == element.templateData.fxScope) return el2;
                        }, undefined);
                    }
                }, undefined);
                if (obj && obj.nodes)
                    return [{ fields: obj.nodes }]
                else
                    return objScope
            }, []);
        }

        //checkParent
        let parentSimpleList = this.getParentSimpleList(element)


        return nodesFields.reduce(function (list, page) {

            page.fields.forEach(function (field) {
                if (field.type === 'group') {
                    /* list = list.concat(field.nodes.filter(function (node) {
                        return (!type || node.type === type) && node.name;
                    })); */
                    list = list.concat(field.nodes.reduce(function (lst, node) {
                        if (node.type == 'group' && node.nodes.length > 0) {
                            lst = lst.concat(node.nodes.filter(function (node) {
                                return (!type || node.type === type) && node.name;
                            }));
                        } else if (node.id == parentSimpleList && node.type == 'simplelist' && node.nodes.length > 0) {
                            lst = lst.concat(node.nodes.filter(function (node) {
                                return (!type || node.type === type) && node.name;
                            }));
                        } else if ((!type || node.type === type) && node.name)
                            lst.push(node)
                        return lst
                    }, []));
                }
                else if (element && field.type === 'simplelist') {
                    if (type === 'simplelist')
                        list.push(field);
                    else {
                        var containsField = field.id == parentSimpleList; /* field.nodes.find(function (node) {
                            return node.id == element.id && node.type === element.type;
                        }); */

                        if (containsField || includeNodesSimpleList) {
                            list = list.concat(field.nodes.reduce(function (lst, node) {
                                if (node.type == 'group' && node.nodes.length > 0) {
                                    lst = lst.concat(node.nodes.filter(function (node) {
                                        return (!type || node.type === type) && node.name && node.id != element.id;
                                    }));
                                } else if ((!type || node.type === type) && node.name && node.id != element.id)
                                    lst.push(node)
                                return lst
                            }, []));
                        }
                    }
                }
                else if (field.name && element.id != field.id && (!type || field.type === type)) {
                    if (checkOptions && field.templateData?.options && field.templateData.options?.length > 0) {
                        if (["select", "multiple"].includes(field.type))
                            list.push(field);
                    } else
                        if (field.id != element.id && (field.type != "formula" || !field.templateData.fxScope || field.templateData.fxScope != parentSimpleList))
                            list.push(field);
                }
            });

            return list;
        }, []);
    };

    this.getElementsFormula = function (type, element, checkOptions = false, container = this._currentContainer, includeNodesSimpleList = false) {
        let nodesFields = container.pages
        if (type != 'simplelist' && element.templateData && element.templateData.fxScope && element.templateData.fxScope != "") {
            //Find Simple List field to get list of nodes
            nodesFields = container.pages.reduce(function (objScope, page) {
                //let obj=page.fields.find(function(el){if(el.id==element.templateData.fxScope) return true});
                let obj = page.fields.reduce(function (res, el) {
                    if (res) return res;
                    if (el.id == element.templateData.fxScope) return el;
                    if (el.nodes) {
                        return el.nodes.reduce(function (res2, el2) {
                            if (res2) return res2
                            if (el2.id == element.templateData.fxScope) return el2;
                        }, undefined);
                    }
                }, undefined);
                if (obj && obj.nodes)
                    return [{ fields: obj.nodes }]
                else
                    return objScope
            }, []);
        }

        //checkParent
        let parentSimpleList = this.getParentSimpleList(element)

        return nodesFields.reduce(function (list, page) {

            page.fields.forEach(function (field) {
                if (field.type === 'group') {
                    /* list = list.concat(field.nodes.filter(function (node) {
                        return (!type || node.type === type) && node.name;
                    })); */
                    list = list.concat(field.nodes.reduce(function (lst, node) {
                        if (node.type == 'group' && node.nodes.length > 0) {
                            lst = lst.concat(node.nodes.filter(function (node) {
                                return (!type || node.type === type);
                            }));
                        } else if (node.id == parentSimpleList && node.type == 'simplelist' && node.nodes.length > 0) {
                            lst = lst.concat(node.nodes.filter(function (node) {
                                return (!type || node.type === type);
                            }));
                        } else if ((!type || node.type === type))
                            lst.push(node)
                        return lst
                    }, []));
                }
                else if (element && field.type === 'simplelist') {
                    if (type === 'simplelist')
                        list.push(field);
                    else {
                        var containsField = field.id == parentSimpleList; /* field.nodes.find(function (node) {
                            return node.id == element.id && node.type === element.type;
                        }); */

                        if (containsField || includeNodesSimpleList) {
                            list = list.concat(field.nodes.reduce(function (lst, node) {
                                if (node.type == 'group' && node.nodes.length > 0) {
                                    lst = lst.concat(node.nodes.filter(function (node) {
                                        return (!type || node.type === type) && node.id != element.id;
                                    }));
                                } else if ((!type || node.type === type) && node.id != element.id)
                                    lst.push(node)
                                return lst
                            }, []));
                        }
                    }
                }
                else if (element.id != field.id && (!type || field.type === type)) {
                    if (checkOptions && field.templateData?.options && field.templateData.options?.length > 0) {
                        if (["select", "multiple"].includes(field.type))
                            list.push(field);
                    } else
                        if (field.id != element.id && (field.type != "formula" || !field.templateData.fxScope || field.templateData.fxScope != parentSimpleList))
                            list.push(field);
                }
            });

            return list;
        }, []);
    };

    this.getElements2 = function (form, type, eleId = undefined, isValidateFields = false) {
        const walk = (arrFields, type, eleId, level = 0) => {
            return arrFields.reduce((ret, field) => {
                ret.hasEleId = ret.hasEleId || (field.id == eleId);
                if (field.type == type || type == undefined) ret.fields.push({ ...field,level:level, name: (field.name || field.label).concat(" (", field.id, ")") });
                if (Array.isArray(field.nodes)) {
                    let ret2 = walk(field.nodes, type, eleId, level+1 );
                    ret.hasEleId = ret.hasEleId || ret2.hasEleId;
                    ret.fields = ret.fields.concat(field.type == "simplelist" && !ret2.hasEleId ? [] : ret2.fields);
                }
                return ret;
            }, { hasEleId: false, fields: [] })

        }
        let lstFields = [];
        form.pages.forEach((page, idx) => {
            lstFields.push(
                {
                    name: "Página ".concat(idx + 1),
                    type,
                    disabled: true
                });
            lstFields = lstFields.concat(walk(page.fields, type, eleId).fields);
        });
        if (isValidateFields) {
            form.validate_pages.forEach(page => {
                lstFields.push(
                    {
                        name: "Validador ",
                        type,
                        disabled: true
                    });
                lstFields = lstFields.concat(walk(page.fields, type, eleId).fields);
            });
        }
        return [
            {
                name: "",
                type,
                isValidateFields,
            },
        ].concat(lstFields);
    };

    return {
        setContainer: function (object) {
            this._currentContainer = object;
        },
        getContainer: function () {
            return this._currentContainer;
        },
        setForm: function (object) {
            this._currentContainer = object;
        },
        getForm: function () {
            return this._currentContainer;
        },
        getElements: this.getElements,
        getElements2: this.getElements2,
        getElementsFormula: this.getElementsFormula,
        getParentSimpleList: this.getParentSimpleList,
        getListOfElements: this.getListOfElements,
        getReportConfigInit: this.getReportConfigInit
    }
}